"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DODOV2 = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const dodov2_proxy_abi_json_1 = __importDefault(require("../../abi/dodov2-proxy.abi.json"));
const MAX_UINT = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
const DODOV2ProxyAddress = {
    1: '0xa356867fdcea8e71aeaf87805808803806231fdc',
    56: '0x8F8Dd7DB1bDA5eD3da8C9daf3bfa471c12d58486',
};
const DODOAproveAddress = {
    1: '0xCB859eA579b28e02B87A1FDE08d087ab9dbE5149',
    56: '0xa128Ba44B2738A558A1fdC06d6303d52D3Cef8c1',
};
class DODOV2 extends adapter_1.default {
    static getDexData(optimalRate, name) {
        const { srcAmount, data: { exchange, tokenFrom, tokenTo, dodoPairs, directions }, } = optimalRate;
        return {
            name,
            fromToken: tokenFrom,
            toToken: tokenTo,
            srcAmount,
            destAmount: '1',
            dodoPairs,
            directions,
            isIncentive: false,
            deadLine: MAX_UINT,
        };
    }
    ethToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dodoContract = new this.web3Provider.eth.Contract(dodov2_proxy_abi_json_1.default, DODOV2ProxyAddress[this.network]);
            const swapData = dodoContract.methods
                .dodoSwapV2ETHToToken(data.toToken, data.destAmount, data.dodoPairs, data.directions, data.isIncentive, data.deadLine)
                .encodeABI();
            return {
                callees: [DODOV2ProxyAddress[this.network]],
                calldata: [swapData],
                values: [data.srcAmount],
            };
        });
    }
    tokenToEthSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dodoContract = new this.web3Provider.eth.Contract(dodov2_proxy_abi_json_1.default, DODOV2ProxyAddress[this.network]);
            const swapData = dodoContract.methods
                .dodoSwapV2TokenToETH(data.fromToken, data.srcAmount, data.destAmount, data.dodoPairs, data.directions, data.isIncentive, data.deadLine)
                .encodeABI();
            const approveCallData = yield this.getApproveCallData(srcToken, data.srcAmount, DODOAproveAddress[this.network]);
            const callees = approveCallData
                ? [approveCallData.callee, DODOV2ProxyAddress[this.network]]
                : [DODOV2ProxyAddress[this.network]];
            const calldata = approveCallData
                ? [approveCallData.calldata, swapData]
                : [swapData];
            const values = approveCallData ? ['0', '0'] : ['0'];
            return {
                callees,
                calldata,
                values,
            };
        });
    }
    tokenToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dodoContract = new this.web3Provider.eth.Contract(dodov2_proxy_abi_json_1.default, DODOV2ProxyAddress[this.network]);
            const swapData = dodoContract.methods
                .dodoSwapV2TokenToToken(data.fromToken, data.toToken, data.srcAmount, data.destAmount, data.dodoPairs, data.directions, data.isIncentive, data.deadLine)
                .encodeABI();
            const approveCallData = yield this.getApproveCallData(srcToken, data.srcAmount, DODOAproveAddress[this.network]);
            const callees = approveCallData
                ? [approveCallData.callee, DODOV2ProxyAddress[this.network]]
                : [DODOV2ProxyAddress[this.network]];
            const calldata = approveCallData
                ? [approveCallData.calldata, swapData]
                : [swapData];
            const values = approveCallData ? ['0', '0'] : ['0'];
            return {
                callees,
                calldata,
                values,
            };
        });
    }
}
exports.DODOV2 = DODOV2;
//# sourceMappingURL=dodov2.js.map